import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { CabeceraPoliticasComponent } from './pages/cabecera-politicas/cabecera-politicas.component';
import { CalderaHidrogenoComponent } from './pages/trabajos/caldera-hidrogeno/caldera-hidrogeno.component';


export const routes: Routes = [
    { path: '', component: HomeComponent},
    { path: 'aviso-legal', component: CabeceraPoliticasComponent },
    { path: 'politica-de-cookies', component: CabeceraPoliticasComponent },
    { path: 'mantenimiento-caldera', loadComponent: () => import('./pages/oferta-mantenimiento/oferta-mantenimiento.component').then(m => m.OfertaMantenimientoPageComponent) },
    {
      path: 'centralgas-industrial/:slug',
      loadComponent: () => import('./pages/centralgas-industrial-detail/centralgas-industrial-detail.component').then(m => m.CentralgasIndustrialDetailComponent)
    },
    { path: 'trabajos/caldera-hidrogeno', component: CalderaHidrogenoComponent }
];
